<template>
  <v-app style="background-color: #f3f6f9">
    <v-main>
      <nav-bar></nav-bar>
      <WhiteList />
    </v-main>
  </v-app>
</template>
<script>
import NavBar from '@/components/widgets/navBar.vue'
import WhiteList from '@/components/admin/whiteListPage/WhiteList.vue'
import Auth from '@/services/auth.service.js'


export default {
  components: {
    NavBar,
    WhiteList
  },
  mounted() {
    document.title = 'White list | ISRASIM'

    let auth = Auth.checkAuth();
    if (!auth) {
      this.$router.replace({ name: "login" })
    }
  },
}
</script>
  